import { datadogLogs } from '@datadog/browser-logs';
import { DataDogEvent } from './types/datadog-error';

class DataDogLogger {
  log(event: DataDogEvent) {
    const { message, data, userEmail } = event;
    datadogLogs.logger.log(message, { ...data, user: userEmail });
  }

  warn(event: DataDogEvent) {
    const { message, data, userEmail } = event;
    datadogLogs.logger.warn(message, { ...data, user: userEmail });
  }

  error(event: DataDogEvent) {
    const { message, data, userEmail } = event;
    datadogLogs.logger.error(message, { ...data, user: userEmail });
  }
}

export const dataDogLog = new DataDogLogger();
